var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }